// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const eztvColors: ColorType = { ...colorPalette, primary: '#CB922A', secondary: '#CB922A' }

export const lightTheme = {
  colors: eztvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: eztvColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: eztvColors.dark,
    secondary: eztvColors.grayText,
    disabled: eztvColors.dark,
    link: eztvColors.dark,
    hint: eztvColors.dark,
    highlight: eztvColors.secondary,
    gray: eztvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#000000',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: eztvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: eztvColors.dark,
    color: eztvColors.dark,
    border: eztvColors.primary,
    scrollbarThumb: eztvColors.primary,
    programTitle: eztvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: eztvColors.dark,
        selected: eztvColors.dark,
        progress: rgba(eztvColors.primary, 0.3),
        past: rgba(eztvColors.primary, 0.3),
        pastSelected: eztvColors.dark,
        pastHover: eztvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(eztvColors.primary, 0.1),
      },
      text: {
        empty: eztvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: eztvColors.dark,
    subTitle: eztvColors.grayText,
    bg: eztvColors.dark,
    number: eztvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 119,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
